import React from "react"
import { htmlDecode } from "../Utils"

const TextGridBlock = ({
  key,
  title=null,
  content=null,
  items=null,
  horizontalTitleAlignment="left",
  titleColor="blue",
  type="one"
}) => {
  let block = 16
  switch (type) {
    case 'two':
      block = 6
      break;
    case 'four':
      block = 3
      break;
    default:
      block = 12
  }

  return (
    <div className="text_grid_block">
      <div className="container">
        <div className="col-12 col-md-10 offset-md-1">
          <div className="row">
            <div className="col">
              {title &&
                <h2 className={ `content-title mb4 ${horizontalTitleAlignment} ${content ? "orange-dash" : ""}` }>{ htmlDecode(title) }</h2>
              }
              {content &&
                <div className="section-content" dangerouslySetInnerHTML={{ __html: content }} />
              }
            </div>
          </div>
        </div>
        <div className="row jcc">
          {type !== 'one' && items &&
            <>
              {items.map((item, index) => (
                <div className={ `mt2 block-col ${type !== 'three' ? "col-12 col-md-" + block : "fb33 ph1.5"} ${index % 2 === 0 ? "pr4" : "pl4"}` }>
                  {item.title &&
                    <h3 className="teaser-header-alt">{ htmlDecode(item.title) }</h3>
                  }
                  {item.content &&
                    <div className="copy" dangerouslySetInnerHTML={{ __html: item.content }} />
                  }
                </div>
              ))}
            </>
          }
        </div>
      </div>
    </div>
  )
}

export default TextGridBlock
